var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellStuffIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8574",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8574",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAACfElEQVR4nO3cwU7UQBzH8d+gNwleNAHOytN4ALnBhRfwBN6VV/A1PGj0OeBO8A00WSEme+LvoSWBiWPKdtr5Rb+fEw1kOvS7bbftZiUAAADUl25/iIhoOZH/XUopSdJa64ngPoKYIYiZx6Vf3B7TMI3SOZs9xAxBzBDEDEHMEMQMQcwQxAxBzBDEDEHMEMQMQcwQxAxBzBDETPF5CM/Y22APMUMQMwQxU3xunp9DeMY+ztDtyR5ihiBmCGKGIGYIYoYgZghipngvaw4R8VzSG0mvJO1IetJoKr8kXUj6IulDSul7o3mURWaC8fci4me+HgOLiNid4P+9p/R3Ta7UI2JP0kf5HjJvJO2nlD7VGnDo9pw9SHSHqUtJGzXGm9BC0stah6/R23PoLrbCxE6zoZcRcRwRW7XWscKctvo5LLO5vau4jnHbc8Ig59nQx7XGHisi3mZzO6s4tm2Q62zozVpjjxURm9ncriqOPWh7tjip5pNxuq3/KFue/TF2iyDfsuXDBnMoOciWL5vM4k8mPGS9z4ZeRsRJRGzXWscKc9ruzx/NT+ot3vY+U/fKe1pjvAktJL1IKf2oMdjQ7Tn7Iat/X3+k7uLL1Y2ko1oxHqLJlXJ/Bbyv7lXoZiHpdUrpc4uVN/2QQ3/4untzcb32Oga6Vndz8au6m4vV94yh25NPnczE9hyCvyOIGYKYIYgZgpghiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYGfytpDW/gAZl7CFmCGKGIAAA/CN+AwKPYQlHy6HyAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellStuffIcon);
export default __webpack_public_path__ + "static/media/SellStuffIcon.f9326e495f2746397313e7e42b1df0c0.svg";
export { ForwardRef as ReactComponent };